import { ElementInfo, ElementType, ElementSceneInfo } from '../types/element.types';
import {
  sortCastItemsByNO,
  compareExportNamesDigitLetterPinyin,
} from './elementSortUtils';

/** 与导出模板 PDF-ScheduleDetail-A4.ts（拍摄计划日历详情 PDF）演员四列汇总一致 */
export type DayRoleSummary = {
  mainNames: string[];
  featuredItems: Array<{ name: string; qty: number }>;
  crowdItems: Array<{ name: string; qty: number }>;
  actionItems: Array<{ name: string; qty: number }>;
  totals: {
    main: number;
    featured: number;
    crowd: number;
    action: number;
  };
};

export function buildDayRoleSummary(
  daySceneIds: Set<string>,
  elements: ElementInfo[],
  elementRelations: ElementSceneInfo[],
): DayRoleSummary {
  const itemById = new Map<string, ElementInfo>();
  elements.forEach((it) => itemById.set(it.elementID, it));
  const maxQtyByItem = new Map<string, number>();
  elementRelations.forEach((rel) => {
    if (!daySceneIds.has(rel.sceneID) || !rel.elementID) return;
    const q = rel.elementQtyInScene || 1;
    maxQtyByItem.set(rel.elementID, Math.max(maxQtyByItem.get(rel.elementID) || 0, q));
  });
  const mainItems: ElementInfo[] = [];
  const featuredItems: Array<{ name: string; qty: number }> = [];
  const crowdItems: Array<{ name: string; qty: number }> = [];
  const actionItems: Array<{ name: string; qty: number }> = [];
  let main = 0;
  let featured = 0;
  let crowd = 0;
  let action = 0;

  Array.from(maxQtyByItem.entries()).forEach(([itemId, qty]) => {
    const item = itemById.get(itemId);
    if (!item?.elementType) return;
    const name = (item.elementName || item.elementAbbr || '').trim();
    if (!name) return;
    if (item.elementType === ElementType.CAST) {
      mainItems.push(item);
      main += 1;
    } else if (item.elementType === ElementType.FEATURED) {
      featuredItems.push({ name, qty });
      featured += qty;
    } else if (item.elementType === ElementType.BACKGROUND) {
      crowdItems.push({ name, qty });
      crowd += qty;
    } else if (item.elementType === ElementType.STUNT_PLAYERS) {
      actionItems.push({ name, qty });
      action += qty;
    }
  });

  const mainSorted = sortCastItemsByNO(mainItems);
  const mainNames = mainSorted
    .map((i) => (i.elementName || i.elementAbbr || '').trim())
    .filter(Boolean);
  featuredItems.sort((a, b) => compareExportNamesDigitLetterPinyin(a.name, b.name));
  crowdItems.sort((a, b) => compareExportNamesDigitLetterPinyin(a.name, b.name));
  actionItems.sort((a, b) => compareExportNamesDigitLetterPinyin(a.name, b.name));

  return {
    mainNames,
    featuredItems,
    crowdItems,
    actionItems,
    totals: { main, featured, crowd, action },
  };
}
